<div class="cluster-report-container">
  <!-- Use getReportTitle() for dynamic title -->
  <h3>{{ getReportTitle() }}</h3>

  <!-- **** NEW: Configuration Console **** -->
  <div class="card mb-3 config-console">
    <div class="card-header">
      <h5 class="mb-0">Clustering Parameters</h5>
    </div>
    <div class="card-body">
      <div class="row g-3 align-items-end">
        <!-- Min Cluster Size -->
        <div class="col-md-4">
          <label for="minClusterSize" class="form-label">Min Cluster Size</label>
          <input type="number" class="form-control form-control-sm" id="minClusterSize"
                 [(ngModel)]="paramMinClusterSize"
                 min="2"
                 [disabled]="isLoading"
                 title="Minimum number of items required to form a cluster (HDBSCAN)">
        </div>
        <!-- Min Samples -->
        <div class="col-md-4">
          <label for="minSamples" class="form-label">Min Samples</label>
          <input type="number" class="form-control form-control-sm" id="minSamples"
                 [(ngModel)]="paramMinSamples"
                 min="1"
                 [disabled]="isLoading"
                 title="How conservative clustering is (larger = more noise). Leave blank/null to default to Min Cluster Size. (HDBSCAN)">
          <!-- Note: Input type number handles null poorly, might need custom handling or default to a number like 5 -->
        </div>
        <!-- Apply Button -->
        <div class="col-md-4">
          <button class="btn btn-primary w-100" (click)="applyParameters()" [disabled]="isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
            Apply & Reload
          </button>
        </div>
      </div>
      <small class="form-text text-muted mt-2 d-block">Adjust parameters and click Apply to re-run the cluster analysis.</small>
    </div>
  </div>
  <!-- **** END: Configuration Console **** -->


  <!-- Loading Indicator -->
  <div *ngIf="isLoading" class="loading-indicator text-center p-4">
    <p>Analyzing clusters... <mat-spinner diameter="30" class="d-inline-block align-middle"></mat-spinner></p>
  </div>

  <!-- Error Message -->
  <div *ngIf="!isLoading && error" class="alert alert-warning error-message">
    <i class="fa fa-exclamation-triangle me-1"></i> {{ error }}
  </div>

  <!-- Main Content Area (Chart and List) -->
  <div *ngIf="!isLoading && !error && clusterReport">

    <!-- **** NEW: Cluster Visualization Chart **** -->
    <div class="chart-container mb-4" style="position: relative; height:400px;">
      <canvas baseChart
              *ngIf="scatterChartDatasets.length > 0"
              [datasets]="scatterChartDatasets"
              [options]="scatterChartOptions"
              [chartType]="scatterChartType"
              [legend]="scatterChartLegend">
      </canvas>
      <div *ngIf="scatterChartDatasets.length === 0" class="text-center text-muted p-5">
        No data points to visualize for the current parameters.
      </div>
    </div>
    <!-- **** END: Cluster Visualization Chart **** -->


    <!-- Existing Cluster List Report -->
    <div class="cluster-list-report">
      <!-- Display Clusters -->
      <div *ngIf="clusterReport.clusters.length > 0; else noClusters">
        <h4>Identified Clusters ({{ clusterReport.clusters.length }})</h4>
        <div class="cluster-list">
          <div
            *ngFor="let cluster of clusterReport.clusters"
            class="cluster-card"
            (mouseenter)="onClusterMouseEnter(cluster.cluster_id)"
            (mouseleave)="onClusterMouseLeave()">

            <h5>
              <!-- Add a color swatch -->
              <span class="cluster-color-swatch me-2"
                    [style.background-color]="CLUSTER_COLORS[cluster.cluster_id % CLUSTER_COLORS.length]"></span>
              Cluster {{ cluster.cluster_id }} ({{ cluster.size }} items)
            </h5>
            <ul class="cluster-item-list">
              <li
                *ngFor="let item of cluster.items"
                (click)="onItemClick(item)"
                title="Click to view details for: {{ item.title }}">
                {{ item.title }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <ng-template #noClusters>
        <p>No distinct clusters were identified with the current settings.</p>
      </ng-template>

      <!-- Display Noise Points -->
      <div *ngIf="clusterReport.noise_points.length > 0" class="noise-section mt-4">
        <h4>
          <!-- Add noise color swatch -->
          <span class="cluster-color-swatch me-2" [style.background-color]="NOISE_COLOR"></span>
          Noise Points ({{ clusterReport.noise_points.length }})
        </h4>
        <p>These items did not strongly belong to any specific cluster:</p>
        <ul class="noise-item-list">
          <li
            *ngFor="let item of clusterReport.noise_points"
            (click)="onItemClick(item)"
            title="Click to view details for: {{ item.title }}">
            {{ item.title }}
          </li>
        </ul>
      </div>
    </div> <!-- End cluster-list-report -->

  </div> <!-- End *ngIf="!isLoading && !error && clusterReport" -->

</div>
